import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { NAV_LINKS, LEGAL_LINKS, LEGAL_IA_LINKS } from "../data/plans";

const renderLink = (link, testId) => {
  const base = {
    color: "var(--osx-text-muted)",
    transition: "color 0.2s ease",
  };
  const enter = (e) => (e.currentTarget.style.color = "var(--osx-brand-600)");
  const leave = (e) => (e.currentTarget.style.color = "var(--osx-text-muted)");
  if (link.to) {
    return (
      <Link to={link.to} data-testid={testId} className="text-sm" style={base} onMouseEnter={enter} onMouseLeave={leave}>
        {link.label}
      </Link>
    );
  }
  return (
    <a
      href={link.href}
      target="_blank"
      rel="noreferrer noopener"
      data-testid={testId}
      className="text-sm"
      style={base}
      onMouseEnter={enter}
      onMouseLeave={leave}
    >
      {link.label}
    </a>
  );
};

export const Footer = () => {
  return (
    <footer
      className="relative pt-16 pb-10"
      style={{
        background: "var(--osx-surface)",
        borderTop: "1px solid var(--osx-border)",
      }}
      data-testid="footer"
    >
      <div className="osx-container">
        <div className="grid gap-10 md:grid-cols-5">
          <div className="md:col-span-2">
            <Logo />
            <p className="mt-4 text-sm max-w-sm leading-relaxed" style={{ color: "var(--osx-text-muted)" }}>
              Hosting premium en Bare Metal con Ryzen 9 y NVMe. Potencia, estabilidad y control absoluto para tus servidores.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-3" style={{ color: "var(--osx-text)" }}>Navegación</h4>
            <ul className="space-y-2">
              {NAV_LINKS.map((link) => (
                <li key={link.to || link.href}>{renderLink(link, `footer-${link.testId}`)}</li>
              ))}
              <li>
                <a
                  href="https://tienda.optishieldx.com/"
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="footer-tienda-link"
                  className="text-sm"
                  style={{ color: "var(--osx-text-muted)", transition: "color 0.2s ease" }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = "var(--osx-brand-600)")}
                  onMouseLeave={(e) => (e.currentTarget.style.color = "var(--osx-text-muted)")}
                >
                  Tienda
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-3" style={{ color: "var(--osx-text)" }}>Legal</h4>
            <ul className="space-y-2">
              {LEGAL_LINKS.map((link) => (
                <li key={link.to}>{renderLink(link, link.testId)}</li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-3" style={{ color: "var(--osx-text)" }}>OptiShield IA</h4>
            <ul className="space-y-2">
              {LEGAL_IA_LINKS.map((link) => (
                <li key={link.to}>{renderLink(link, link.testId)}</li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className="mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4"
          style={{ borderTop: "1px solid var(--osx-border)" }}
        >
          <p className="text-xs" style={{ color: "var(--osx-text-muted)" }}>
            &copy; {new Date().getFullYear()} OptiShield X. Todos los derechos reservados.
          </p>
          <a
            href="https://status.optishieldx.com/"
            target="_blank"
            rel="noreferrer noopener"
            className="inline-flex items-center gap-2 text-xs font-mono"
            style={{ color: "var(--osx-text-muted)" }}
            data-testid="footer-status-badge"
          >
            <span className="relative inline-flex h-1.5 w-1.5">
              <span className="absolute inset-0 rounded-full animate-ping" style={{ background: "#10b981" }} />
              <span className="relative inline-flex h-1.5 w-1.5 rounded-full" style={{ background: "#10b981" }} />
            </span>
            Todos los sistemas operativos
          </a>
        </div>
      </div>
    </footer>
  );
};
